import useGetProductsByUser from './useGetProductsByUser'

export default useGetProductsByUser
